<template>
  <div class="ImageUpload">
    <div class="input-field">
      <input
          :id="id"
          accept="image/jpeg,image/png,application/pdf"
          autocomplete="off"
          type="file"
          @change="inputChanged"
      />
      <label :for="id">{{ buttonText }}</label>
    </div>
  </div>
</template>

<script>
import { uniqueId } from 'lodash'
import { toImage, toText } from '@/services/PDFService'

export default {
  name: 'ImageUpload',
  props: {
    placeholder: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      id: null,
      value: null,
    }
  },
  mounted () {
    this.id = uniqueId('input-field-group-')
  },
  computed: {
    buttonText () {
      return this.placeholder
    },
  },
  methods: {
    async inputChanged (event) {
      const file = document.getElementById(this.id).files[0]
      const reader = new FileReader()

      if (file.type === 'image/png' || file.type === 'image/jpeg') {
        reader.addEventListener(
            'load',
            () => {
              this.$emit('input', reader.result)
            },
            false
        )

        if (file) {
          reader.readAsDataURL(file)
        }
      } else if(file.type === 'application/pdf') {
        let extractedContent = await toText(file, 0)
        this.$emit('contentExtracted', extractedContent)
        
        await toImage(file).then(result => {
          // console.log(result);
          this.$emit('input', result[0])
        })
      } else {
        this.$root.showSnackbar("Dozwolone są tylko formaty jpg/jpeg, png oraz pdf!", "error")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.ImageUpload {
  width: 100%;
  margin: 10px 0;

  .preview {
    height: 200px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .input-field {
    margin-top: 16px;
    display: flex;

        label {
            width: 100%;
            padding: 16px 0;
            cursor: pointer;
            border: 1px dashed $grey-light;
            color: $grey-light;
            text-align: center;
        }

    input {
      display: none;
    }
  }
}
</style>
